import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { Domain } from '../../../models/domain.model';
import { DomainService } from '../../../../core/data-services/domain.service';
import { PaginatedList } from '../../../../xform-compat';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'rms-domain-selector',
    templateUrl: './domain-selector.component.html',
    styleUrls: ['./domain-selector.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => DomainSelectorComponent)
        }
    ],
    standalone: false
})
export class DomainSelectorComponent implements OnInit, ControlValueAccessor {

  @Input() selectedDomains: Array<any> = [];
  @Output() selectedDomainsChange: EventEmitter<any> = new EventEmitter<any>();

  @Input() selectedDomain: Domain = new Domain();
  @Input() selectedDomainChange: EventEmitter<any> = new EventEmitter<any>();

  @Input() label = 'Domain';
  @Input() placeholder = '';
  @Input() multiple = true;
  @Input() isRequired = false;
  @Input() relevances = ['DEFAULT'];

  public domainList: Array<Domain> = new Array<Domain>();
  public loading = false;
  public disabled = false;
  public onChange = (_: any) => {};

  constructor(
    private domainService: DomainService
  ) { }

  ngOnInit() {
    this.loadDomains();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    if (this.multiple) {
      if (!obj || obj instanceof Array) {
        this.selectedDomains = obj;
      } else {
        this.selectedDomains = [...this.selectedDomains, obj];
      }
    } else {
      this.selectedDomain = obj;
    }
  }

  public searchFn(term: string, item: Domain): boolean {
    return item.name.toUpperCase().includes(term.toUpperCase());
  }

  private loadDomains() {
    this.loading = true;
    this.domainService.domains.subscribe((resp: PaginatedList<Domain>) => {
      this.loading = false;
      if (resp) {
        this.domainList = resp.records.filter(d => this.relevances.includes(d.relevance))
          .sort((a, b) => a.name.localeCompare(b.name));
      } else {
        this.domainList = [];
      }
    }, () => {
      this.domainList = [];
      this.loading = false;
    });
  }

  onDomainChange(value: any): void {
    if (this.multiple) {
      this.selectedDomains = value;
      this.selectedDomainsChange.emit(value); // emits the new value
    } else {
      this.selectedDomain = value;
      this.selectedDomainChange.emit(value);
    }
  }

}
